module.exports = __webpack_public_path__ + "static/img/GANG APPLE.368a2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/GANG APPLE.png
// module id = Mb9K
// module chunks = 1